import React, { FC } from 'react';
import styled from 'styled-components';
import { LogoLeftPanel } from 'src/common/images/LogoLeftPanel';
import { HomepageRoute } from 'src/public/publicRoutes';
import { SpeakerListingYoutubeCard } from 'src/public/components/speaker-listing/SpeakerListingYoutubeCard';
import { GatsbyLink } from 'src/common/migration/GatsbyLink';
import { PartnerLogoDesktop } from 'src/common/components/PartnerLogoDesktop';

const StyledLink = styled(GatsbyLink)`
  display: inline-block;
  margin: 2.375rem 0 1.5625rem 2.125rem;
`;

const CardContainer = styled.div`
  margin-top: 0.9375rem;
`;

const PanelContainer = styled.div`
  align-self: flex-start;
  position: sticky;
  top: 0;
  margin-bottom: 4rem;
  width: 100%;
`;

export const SpeakerListingLeftPanel: FC = () => (
  <PanelContainer>
    <StyledLink to={HomepageRoute}>
      <LogoLeftPanel />
    </StyledLink>

    <PartnerLogoDesktop />

    <CardContainer>
      <SpeakerListingYoutubeCard leftPanel />
    </CardContainer>
  </PanelContainer>
);
